<template>
<div class=""  style="padding:0 20px;">
  <el-form ref="formBasic" :model="$abstract.profile.row" @submit.native.prevent="onSubmit" :rules="rules" label-width="180px" style="margin-top:20px;" class="label-30">

  <div class="title_h1 yo-color-primary">EMAIL PRESENTING AUTHOR</div>
  <div class="yo-text-s yo-color-secondary" style="margin:8px 0 24px 0;">» {{$abstract.profile.row.titolo}}</div>
        
  <div class="row " style="margin-top:20px;">

    <div class="col s12">
    <el-form-item label="Email" prop="emailprimoautore">
      <el-input  v-model="$abstract.profile.row.emailprimoautore"></el-input>
    </el-form-item>
    </div> 

  </div>

  <div class="row " style="margin-top:20px;">

    <!--<div class="yo-text-l yo-text-bold yo-color-success">OTHER INFORMATION</div> -->
    <div>
    Here you can add the email address of the presenting author of the abstract, that will be present during the Symposium for the presentation of your work.
 </div>

  </div>  

    <div class="row pad" style="margin-top:20px;border-top:1px solid grey;padding-top:30px;padding-bottom:30px;">
      <div class="col s6 m4 offset-m2">
          <el-button style="width:100%;margin:10px 0;"  @click="onCancel">Cancel</el-button>
      </div>
        
      <div class="col s6 m4 offset-m2" >
          <el-button type="primary" @click="onSubmit" style="width:100%;background-color:#72BF44;border:none;margin:10px 0;">Save</el-button>
      </div>
    </div>


    </el-form>
</div>
</template>

<script>
export default {
  name: 'abstract-emailprimoautore',
  created () {
    console.log("Arrivo al abstract-emailprimoautore.vue con id "+this.$abstract.profile.row.id)
  }
  ,methods: {
    onCancel() {
      this.$router.push('/home/')
    },
    onSubmit() {
      this.$refs.formBasic.validate(async (valid) => {
        if (valid) {  
         this.Save()
        } else {
          this.$alert('Not all fields have been filled in correctly!', this.$teras.alert_error)
          return false;
        }
      });
    },
    async Save(){
      await this.$abstract.profile.save() 
      await this.$contatto.getAbstract() 
      console.log(this.$contatto._abstract)
      this.$router.push('/home/')      
    }

  },
  computed: {
    rules:function() {
      var rulesNow = {
        emailprimoautore: [
          { required: true, message: 'Email first author is mandatory', trigger: 'blur' }
        ]
      }
      return rulesNow
    }
  }
}
</script>
<style scoped>
</style>